import { Injectable } from "@angular/core";
import { Timeframe } from "../models/timeframe";
import * as firebase from "firebase";
import * as moment from "moment";

@Injectable({
  providedIn: "root"
})
export class DateService {
  public timeframes: Record<string, Timeframe> = {
    Today: this.today,
    Yesterday: this.yesterday,
    "Week to Date": this.weekToDate,
    "Last 7 Days": this.last7Days,
    "Last Week": this.lastWeek,
    "Last 30 Days": this.last30Days,
    "Last Month": this.lastMonth,
    "Month to Date": this.monthToDate,
    "Year to Date": this.yearToDate,
    "Last 12 Months": this.last12Months,
    "Last Calendar Year": this.lastCalendarYear,
    "All Time": this.allTime,
    "Custom Date": null
  };

  get localTime(): moment.Moment {
    return moment();
  }

  get timestamp() {
    return firebase.firestore.Timestamp.fromDate;
  }

  get today(): Timeframe {
    const begin = moment()
      .startOf("day")
      .toDate();
    const end = moment().toDate();
    return new Timeframe(this.timestamp(begin), this.timestamp(end));
  }

  get yesterday(): Timeframe {
    const begin = moment()
      .startOf("day")
      .subtract(1, "day")
      .toDate();
    const end = moment()
      .startOf("day")
      .toDate();
    return new Timeframe(this.timestamp(begin), this.timestamp(end));
  }

  get weekToDate(): Timeframe {
    const begin = moment()
      .startOf("week")
      .toDate();
    const end = moment().toDate();
    return new Timeframe(this.timestamp(begin), this.timestamp(end));
  }

  get last7Days(): Timeframe {
    const begin = moment()
      .startOf("day")
      .subtract(7, "days")
      .toDate();
    const end = moment().toDate();
    return new Timeframe(this.timestamp(begin), this.timestamp(end));
  }

  get lastWeek(): Timeframe {
    const begin = moment()
      .startOf("week")
      .subtract(7, "days")
      .add(4, "hours")
      .toDate();
    const end = moment()
      .startOf("week")
      .toDate();
    return new Timeframe(this.timestamp(begin), this.timestamp(end));
  }

  get last30Days(): Timeframe {
    const begin = moment()
      .startOf("day")
      .subtract("30", "days")
      .toDate();
    const end = moment().toDate();
    return new Timeframe(this.timestamp(begin), this.timestamp(end));
  }

  get lastMonth(): Timeframe {
    const begin = moment()
      .startOf("month")
      .subtract("1", "month")
      .toDate();
    const end = moment()
      .startOf("month")
      .toDate();
    return new Timeframe(this.timestamp(begin), this.timestamp(end));
  }

  get monthToDate(): Timeframe {
    const begin = moment()
      .startOf("month")
      .toDate();
    const end = moment()
      .endOf("month")
      .toDate();
    return new Timeframe(this.timestamp(begin), this.timestamp(end));
  }

  get yearToDate(): Timeframe {
    const begin = moment()
      .startOf("year")
      .toDate();
    const end = moment()
      .endOf("year")
      .toDate();

    return new Timeframe(this.timestamp(begin), this.timestamp(end));
  }

  get last12Months(): Timeframe {
    const begin = moment()
      .startOf("day")
      .subtract(12, "months")
      .toDate();
    const end = moment().toDate();
    return new Timeframe(this.timestamp(begin), this.timestamp(end));
  }

  get lastCalendarYear(): Timeframe {
    const begin = moment()
      .startOf("year")
      .subtract(1, "year")
      .toDate();
    const end = moment()
      .startOf("year")
      .toDate();
    return new Timeframe(this.timestamp(begin), this.timestamp(end));
  }

  get allTime(): Timeframe {
    5;
    const begin = moment("20190504", "YYYYMMDD").toDate();
    const end = moment().toDate();
    return new Timeframe(this.timestamp(begin), this.timestamp(end));
  }

  custom(begin: Date, end: Date): Timeframe {
    return new Timeframe(this.timestamp(begin), this.timestamp(end));
  }

  getUniqueDates(dates: moment.Moment[]): Date[] {
    const result = dates.reduce(
      (a, c) => ((a[c.format("MM/DD/YYYY")] = c), a),
      {}
    );
    return (Object.values(result) as moment.Moment[]).map(mom => mom.toDate());
  }

  isSameDate(a: Date, b: Date) {
    return moment(a).format("MM/DD/YY") == moment(b).format("MM/DD/YY");
  }

  getString(d: Date) {
    return moment(d).format("MM/DD/YY");
  }

  getBlackoutString(from: Date, to?: Date) {
    if (to == null) {
      return moment(from).format("MM/DD/YY");
    } else {
      return (
        moment(from).format("MM/DD/YY") + " - " + moment(to).format("MM/DD/YY")
      );
    }
  }

  static d2tz(date: Date, timezone: string) {
    var invdate = new Date(
      date.toLocaleString("en-US", {
        timeZone: timezone
      })
    );
    var diff = date.getTime() - invdate.getTime();
    return new Date(date.getTime() - diff);
  }
  static ts2tz(ts: firebase.firestore.Timestamp, timezone: string) {
    var invdate = new Date(
      ts.toDate().toLocaleString("en-US", {
        timeZone: timezone
      })
    );
    var diff = ts.toDate().getTime() - invdate.getTime();
    return firebase.firestore.Timestamp.fromDate(
      new Date(ts.toDate().getTime() - diff)
    );
  }
  static d2ts(d: Date): firebase.firestore.Timestamp {
    return firebase.firestore.Timestamp.fromDate(d);
  }
}
